import gql from 'graphql-tag'

export const redesSociais = gql`
  query redesSociaisQuery($marca: String!) {
    redesSociais(marca: $marca) {
      id
      nome
      url
      icone
    }
  }
`
